function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionMultipleCouponsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 22.5a1.25 1.25 0 102.5 0V21a1.25 1.25 0 10-2.5 0v1.5zM12 18.25c-.69 0-1.25-.56-1.25-1.25v-1.5a1.25 1.25 0 112.5 0V17c0 .69-.56 1.25-1.25 1.25z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8a3 3 0 00-3 3v4.034c0 .264.235.466.5.466a3.5 3.5 0 110 7c-.265 0-.5.201-.5.466V27a3 3 0 003 3h17a3 3 0 003-3v-4.034c0-.265-.235-.466-.5-.466a3.5 3.5 0 110-7c.265 0 .5-.201.5-.466V11a3 3 0 00-3-3H5zm0 2.5a.5.5 0 00-.5.5v2.341a6.003 6.003 0 010 11.318V27a.5.5 0 00.5.5h5.75v-1a1.25 1.25 0 112.5 0v1H22a.5.5 0 00.5-.5v-2.341a6.003 6.003 0 010-11.318V11a.5.5 0 00-.5-.5h-8.75v1a1.25 1.25 0 11-2.5 0v-1H5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 3a3 3 0 013 3v5c0 .5-.5 1-1 1-1 0-1.5.5-2 1v-2.5s.139-2.361-1-3.5c-1.139-1.139-2.816-1-2.816-1h-15a3 3 0 013-3H27zM26 17c.5 0 1-.5 1-1 0 0 .5 1 1.5 1 .868 0 1.5.667 1.5 1v4c0 2-2 2.833-3 3v-4h-1c-1 0-3-.4-3-2 0-2 2-2 3-2z",
    fill: props.color
  }));
}

export default SvgIconPromotionMultipleCouponsFilled;